function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import filter from 'lodash/filter';
import map from 'lodash/map';
import Avatar from 'components/Avatar';
import * as selectors from '../../../selectors';
import * as shapes from '../../../shapes';
import messages from '../../../messages';
import styles from './ClinicMemberships.pcss';
var _React_PureComponent;
class OrganizationMemberships extends (_React_PureComponent = React.PureComponent) {
    renderAvatar(profile) {
        if (!profile) {
            return null;
        }
        return /*#__PURE__*/ _jsx(Avatar, {
            avatarImg: profile.avatar,
            name: [
                profile.firstName,
                profile.lastName
            ],
            className: styles.avatar,
            imgClassName: styles.avatar__img,
            initialsClassName: styles.avatar__initials
        });
    }
    renderOrganizationMembership(hcpInvitation) {
        const { identityUID, businessEmail, firstName, lastName } = hcpInvitation;
        return /*#__PURE__*/ _jsxs("tr", {
            children: [
                /*#__PURE__*/ _jsx("td", {
                    className: "cell--avatar",
                    children: this.renderAvatar({
                        firstName,
                        lastName
                    })
                }),
                /*#__PURE__*/ _jsxs("td", {
                    className: "w-33",
                    children: [
                        firstName,
                        " ",
                        lastName
                    ]
                }),
                /*#__PURE__*/ _jsx("td", {
                    children: businessEmail
                })
            ]
        }, identityUID);
    }
    renderOrganizationMemberships(hcpInvitations) {
        return /*#__PURE__*/ _jsx("div", {
            className: "section__table-container",
            children: /*#__PURE__*/ _jsxs("table", {
                className: "section__table",
                children: [
                    /*#__PURE__*/ _jsx("thead", {
                        className: "section__table__head",
                        children: /*#__PURE__*/ _jsxs("tr", {
                            children: [
                                /*#__PURE__*/ _jsx("th", {
                                    colSpan: 2,
                                    children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.labels.hcp))
                                }),
                                /*#__PURE__*/ _jsx("th", {
                                    children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.labels.email))
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ _jsx("tbody", {
                        className: "section__table__body",
                        children: map(hcpInvitations, (hcpInvitation)=>this.renderOrganizationMembership(hcpInvitation))
                    })
                ]
            })
        });
    }
    render() {
        const { status, headerMessage } = this.props;
        const organizationMemberships = filter(this.props.organizationMemberships, {
            status
        });
        if (!organizationMemberships.length) {
            return null;
        }
        return /*#__PURE__*/ _jsxs("div", {
            className: "pt-10",
            children: [
                /*#__PURE__*/ _jsx("h2", {
                    className: "row section__header",
                    children: /*#__PURE__*/ _jsx("span", {
                        className: "col",
                        children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, headerMessage))
                    })
                }),
                this.renderOrganizationMemberships(organizationMemberships)
            ]
        });
    }
}
_define_property(OrganizationMemberships, "propTypes", {
    // Explicit props
    status: PropTypes.oneOf([
        'Invitation',
        'Pending'
    ]).isRequired,
    headerMessage: PropTypes.object,
    // Implicit props
    organizationMemberships: PropTypes.arrayOf(shapes.organizationMembership)
});
const mapStateToProps = (state)=>({
        organizationMemberships: selectors.organizationMemberships(state)
    });
const ConnectedOrganizationMemberships = connect(mapStateToProps)(OrganizationMemberships);
export default ConnectedOrganizationMemberships;
